// Write your code here.
import './index.css'

const WinOrLoseCard = props => {
  const {score, topScore, toPlayAgain} = props
  const winOrLose =
    score >= 12
      ? {
          a: 'You Won',
          b: 'Best Score',
          imgs: 'https://assets.ccbp.in/frontend/react-js/won-game-img.png',
        }
      : {
          a: 'you Lose',
          b: 'Score',
          imgs: 'https://assets.ccbp.in/frontend/react-js/lose-game-img.png',
        }
  const {a, b, imgs} = winOrLose
  return (
    <div className="WinOrLoseCard">
      <div className="winOrLose_1">
        <h1>{a}</h1>
        <p>{b}</p>
        <p className="as">{score}/12</p>
        <button type="button" onClick={toPlayAgain}>
          Play Again
        </button>
      </div>
      <img className="image" alt="win or lose" src={imgs} />
    </div>
  )
}
export default WinOrLoseCard
